<template>
    <div class="page-container">
        <div style="width: 100%; padding-bottom: 20px">
            <Transition name="fade">
                <el-form
                    v-if="formVisible"
                    :inline="true"
                    class="search-form"
                    :model="queryForms"
                    label-position="top"
                    style="padding: 0 20px"
                >
                    <el-form-item label="名称">
                        <el-input style="width: 165px" v-model="queryForms.name" clearable placeholder="请输入名称" />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" :icon="Search" @click="getTableData">搜索</el-button>
                        <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                    </el-form-item>
                </el-form>
            </Transition>
            <el-card class="noBorder" style="flex: 1">
                <div style="display: flex; margin-bottom: 10px">
                    <el-button type="primary" :icon="Plus" @click="onAddClick()" v-permission="['subsystem-config:add']">
                        添加
                    </el-button>
                    <el-button @click="uploadVisible = true" :icon="Download" v-permission="['subsystem-config:import']">
                        导入
                    </el-button>
                    <el-button @click="handleExport" :icon="Upload" v-permission="['subsystem-config:export']">导出</el-button>
                    <div class="card-header" style="margin-left: auto">
                        <div class="circle-btn">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                :content="formVisible ? '隐藏搜索' : '显示搜索'"
                                placement="top"
                            >
                                <el-button
                                    plain
                                    circle
                                    @click="formVisible = !formVisible"
                                    :icon="Search"
                                    size="small"
                                ></el-button>
                            </el-tooltip>
                            <el-tooltip class="box-item" effect="dark" content="刷新" placement="top">
                                <el-button plain circle @click="getTableData" :icon="Refresh" size="small"></el-button>
                            </el-tooltip>
                        </div>
                    </div>
                </div>
                <el-table
                    :data="table_data"
                    border
                    style="width: 100%"
                    v-loading="tableLoading"
                    row-key="id"
                    :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                    height="calc(100vh - 330px)"
                >
                    <el-table-column label="子系统名称" prop="name"></el-table-column>
                    <el-table-column label="服务器名称" prop="server_name"></el-table-column>
                    <el-table-column label="服务器ip" prop="server_ip"></el-table-column>
                    <el-table-column label="端口" prop="server_port"></el-table-column>
                    <el-table-column label="key" prop="key"></el-table-column>
                    <el-table-column label="秘钥" prop="secret"></el-table-column>
                    <el-table-column label="操作" fixed="right" width="180">
                        <template #default="{ row }">
                            <el-button
                                type="primary"
                                link
                                :icon="View"
                                size="small"
                                v-permission="['subsystem-config:detail']"
                                @click="onShowClick(row)"
                            >
                                详情
                            </el-button>
                            <el-button
                                type="primary"
                                link
                                :icon="Edit"
                                size="small"
                                @click="onEditClick(row)"
                                v-permission="['subsystem-config:edit']"
                            >
                                编辑
                            </el-button>
                            <el-button
                                type="primary"
                                :icon="Delete"
                                link
                                size="small"
                                @click="onRemoveClick({ data: row, api: deleteDevice })"
                                v-permission="['subsystem-config:remove']"
                            >
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <Pagination
                    :current-page="page"
                    :page-size="page_size"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                ></Pagination>
            </el-card>
        </div>
        <forms-dialog
            v-if="formDialogVisible"
            v-model="formDialogVisible"
            :isForm="isForm"
            :modelId="selectModelId"
            :detailData="detail_data"
            @updateForm="getTableData"
        ></forms-dialog>
        <imports-form
            v-if="uploadVisible"
            v-model="uploadVisible"
            @updateForm="getTableData"
            menuCode="heating/device"
        ></imports-form>
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { Delete, Download, Edit, Plus, Refresh, Search, Upload, View } from '@element-plus/icons'
import { deleteDevice, getDeviceList } from '@/api/heating/devicePoint/devicePoint.js'
import FormsDialog from './components/forms.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import ImportsForm from '@/components/ImportsForm.vue'
import useTable from '@/hooks/useTable'
import Pagination from '@/components/Pagination/index.vue'

const formVisible = ref(true)

// 重置
const resetQueryForm = () => {
    delete queryForms.value.online
    Object.keys(queryForms.value).forEach((key) => {
        if (key !== 'module' && key !== 'room' && key !== 'building') queryForms.value[key] = ''
    })
    getTableData()
}
// 数据源
const queryForms = ref({
    name: ''
})
const { page, page_size, total, table_data, tableLoading, getTableData, handleCurrentChange, handleSizeChange, onRemoveClick } =
    useTable(getDeviceList, queryForms.value)

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectModelId = ref('') // 点中的模块id
const detail_data = ref({})
// 保证每次打开重新获取数据
watch(formDialogVisible, (val) => {
    if (!val) selectModelId.value = ''
})

// 查看
const onShowClick = (row) => {
    isForm.value = false
    selectModelId.value = row.id
    detail_data.value = row
    formDialogVisible.value = true
}
// 编辑
const onEditClick = (row) => {
    isForm.value = true
    selectModelId.value = row.id
    detail_data.value = row
    formDialogVisible.value = true
}
// 添加
const onAddClick = () => {
    isForm.value = true
    selectModelId.value = ''
    detail_data.value = {}
    formDialogVisible.value = true
}

// 删除

const uploadVisible = ref(false)
// 导出
const handleExport = async () => {
    ElMessageBox.confirm('您确定导出全部设备点位信息吗？', {
        type: 'warning'
    })
        .then(async () => {
            const { data } = await getDeviceList({ ...queryForms.value, export: 1 })
            window.open(data)
            ElMessage.success('导出成功')
        })
        .catch(() => {})
}

// 切换到前台时候执行
onMounted(() => {
    getTableData()
})
</script>

<style scoped></style>
